import { useField } from 'formik';
import { unitFieldName } from '../../../quoteOrDesignFormFieldNameHelpers';

export const useUnitJsonField = <T>(unitIndex: number, fieldName: string) => {
  const [field, , helpers] = useField(unitFieldName(unitIndex, fieldName));
  const value = field.value !== '' ? (JSON.parse(field.value) as T) : null;
  const setValue = (newValue: T) => {
    helpers.setValue(JSON.stringify(newValue));
  };

  return { value, setValue };
};
